import { FaMapMarkerAlt, FaEye, FaUserCircle } from "react-icons/fa";
import { Row, Col, Button } from "reactstrap";
import playerImage from "../../../../src/assets/images/playerExemple.jpeg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL } from "constants/ApiUrl";
import { setPlayerToChat } from "store/slices/agentSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

const AgentPlayerInfo = ({ player }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    _id,
    firstName,
    lastName,
    position,
    dateOfBirth,
    photo,
    nationality,
    currentClub,
    category,
    biography,
    height,
    weight,
    subscriptionStartDate,
    subscriptionEndDate,
    createdAt,
  } = player;

  const birth = new Date(dateOfBirth);
  const age = new Date().getFullYear() - birth.getFullYear();

  const fmt = (iso) => new Date(iso).toLocaleDateString();
  const [playerPhoto, setPlayerPhoto] = useState(null);
  useEffect(() => {
    if (photo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');

      let cleanLogo = photo.replace(/\\/g, '/').replace(/^\/+/, '');

      if (!cleanLogo.startsWith('uploads/')) {
        cleanLogo = 'uploads/' + cleanLogo;
      }
      setPlayerPhoto(`${cleanApiUrl}/${cleanLogo}`);
    }
  }, [player])

  return (
    <div
      style={{
        marginTop: 15,
        padding: "20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "10px",
      }}
    >
      <Row>
        <Col
          md={4}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
          >
            {playerPhoto ?
              <img
                src={playerPhoto}
                alt={`${firstName} ${lastName}`}
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: 15,
                }}
              />
              :
              <FaUserCircle size={72} className="text-secondary" style={{ marginRight: "15px" }} />
            }
            <div>
              <h4 style={{ margin: 0 }}>
                {firstName} {lastName}
              </h4>
              <div style={{ fontSize: 14, color: "#666" }}>{category}</div>
            </div>
          </div>

          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>{t("agentPlayerInfo.position")}:</strong> {position}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Age:</strong> {age}
            </p>
            <p style={{ margin: "5px 0" }}>
              <FaMapMarkerAlt style={{ marginRight: 4, color: "#007bff" }} />
              {nationality}
            </p>
          </div>
        </Col>

        <Col md={4}>
          <p>
            <strong>{t("agentPlayerInfo.currentClub")}:</strong> {currentClub}
          </p>
          <p>
            <strong>{t("agentPlayerInfo.dateOfBirth")}:</strong>{" "}
            {fmt(dateOfBirth)}
          </p>
          <p>
            <strong>{t("agentPlayerInfo.heightWeight")}:</strong> {height} cm /{" "}
            {weight} kg
          </p>
          <div style={{ marginTop: 20 }}>
            <h6 style={{ fontWeight: "bold" }}>
              {t("agentPlayerInfo.biography")}
            </h6>
            <p style={{ fontSize: 14, lineHeight: 1.4 }}>{biography}</p>
          </div>
        </Col>

        <Col
          md={4}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p>
              <strong>{t("agentPlayerInfo.memberSince")}:</strong>{" "}
              {fmt(createdAt)}
            </p>
            <p>
              <strong>{t("agentPlayerInfo.subscription")}:</strong>
            </p>
            <ul style={{ paddingLeft: 20, margin: "5px 0" }}>
              <li>
                {t("agentPlayerInfo.subscriptionStart")}:{" "}
                {fmt(subscriptionStartDate)}
              </li>
              <li>
                {t("agentPlayerInfo.subscriptionEnd")}:{" "}
                {fmt(subscriptionEndDate)}
              </li>
            </ul>
          </div>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <Button
              color="primary"
              style={{ backgroundColor: "#157088", borderRadius: "5px" }}
              onClick={() => {
                dispatch(setPlayerToChat(player));
                navigate(`/chat/${_id}`);
              }}
            >
              {t("playerInfo.contact")}
            </Button>
            <Button
              style={{
                color: "#157080",
                borderColor: "#157080",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "8px",
              }}
              outline
              onClick={() => {
                navigate(`/joueurs/playerInfo/${_id}`);
              }}
            >
              {t("playerInfo.seeProfile")}
              <FaEye style={{ color: "#157080" }} />
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default AgentPlayerInfo;
